// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3kAiC","rootSuccess":"CompleteLink_rootSuccess__2MQFE","rootFailure":"CompleteLink_rootFailure__1K95T","isDisabled":"CompleteLink_isDisabled__2jJDG"};